<div #mytemplate>
<app-guest-property-guides-desktop *ngIf="isDesktopMode() && property" [booking]="booking" [property]="property"></app-guest-property-guides-desktop>
</div>
